import { AxiosError } from "axios";

export const getApiErrorMessage = (err: unknown): string | null => {
  if (!(err instanceof AxiosError) || !err.response?.data) {
    return null;
  }

  const data = err.response.data as Record<string, unknown>;
  const strMensagem = data.strMensagem as string | undefined;
  const message = data.message as string | undefined;
  const errorObj = data.error as { Message?: string } | undefined;

  return strMensagem || message || errorObj?.Message || null;
};
